export type ContextType = "client" | "admin";

/**
 * Determines the context type based on the provided options, either "client" or "admin".
 *
 * @param opts - An object containing the following property:
 *   - `clientId` (string | undefined | null): The client identifier.
 *
 * @returns "client" if `clientId` is provided, otherwise "admin".
 */
export function getContextType(opts: {
  clientId: string | undefined | null;
}): ContextType {
  const { clientId } = opts;

  if (clientId) {
    return "client";
  }

  return "admin";
}
